import React from "react";
import "./alloy-wheel.scss";
import checked_icon from "../../assets/checkedIconGreen.webp";
import { StaticImage } from "gatsby-plugin-image";
import { checkTheme } from "../../utils/informations"


const AlloyWheel = ({ props, origin }) => {
    return (
        <>
            {
                props.filter((item) => item.origin === origin).map((obj, index) => {
                    const { title, description, benefitsListItems, criteriaListItems, pinkPig, bluePig } = obj;

                    return (
                        <div className="alloy-wheel-box" key={index}>
                            <div className="alloy-wheel-content">
                                <div>
                                    <h2 className="alloy-wheel-title">{title}</h2>
                                </div>
                                <div className="alloy-wheel-text-column">
                                    <p>{description}</p>
                                    <div className="section-aw">
                                        <h3 className="section-alloyW">Vehicle purchased
                                            <span className="section-alloyW-cont">within 90 days</span>
                                        </h3>
                                    </div>

                                    <div className="alloy-wheel-lists">
                                        <div className="lists-check-icon uk-child-width-1-2@m uk-grid-small uk-grid-match" uk-grid="true">
                                            {
                                                benefitsListItems.map((data, index) => {
                                                    return (
                                                        <ul className="check-points">
                                                            <img className="check-img" alt="product-benefits" src={checked_icon} align="left" />
                                                            <li key={index}>{data.itemList}</li>
                                                        </ul>
                                                    )
                                                }
                                                )
                                            }
                                        </div>
                                    </div>

                                    <div className="section-aw">
                                        <h3 className="section-alloyW">Vehicle purchased
                                            <span className="section-alloyW-cont">over 90 days ago</span>
                                        </h3>
                                    </div>
                                    <div>
                                        {
                                            criteriaListItems.map((data, index) => {
                                                return (
                                                    <p key={index}>{data.itemList}</p>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            </div>

                            {pinkPig ?
                                <div className={checkTheme().pageTitle.includes("Invictus") || checkTheme().pageTitle.includes("Alternative") ? "display-no-piggies" : ""}>
                                    <StaticImage src='../../assets/pink_flipped_cut.png' alt="pig_icon" className="pink_flipped_cut" />
                                </div>
                                : ""}

                            {bluePig ?
                                <div className={checkTheme().pageTitle.includes("Invictus") || checkTheme().pageTitle.includes("Alternative") ? "display-no-piggies" : ""}>
                                    <StaticImage src='../../assets/halfBluePig.png' alt="pig_icon" className="blue_flipped" />
                                </div>
                                : ""}
                        </div>
                    )

                })
            }

        </>
    )
}

export default AlloyWheel;